export default __webpack_public_path__ + "static/media/gallery-wip-grenade v2_10.a4960c0b.jpg";